import DTOCriteria = namaTypes.DTOCriteria;
import Operator from "@/utils/constants/Operator.ts";
import ExpressionRelationship from "@/utils/constants/ExpressionRelationship.ts";
import {StringUtils} from "@/utils/common/StringUtils.ts";

export default class CriteriaUtils
{
  static joinCriteria(criteria1: DTOCriteria, criteria2?: DTOCriteria): DTOCriteria {
    if (!criteria1.expressions)
      criteria1.expressions = [];
    if (criteria2 && criteria2.expressions) {
      let size = criteria1.expressions.length;
      if (size > 0) {
        criteria1.expressions.unshift({operator: Operator.OpenBracket, relation: ExpressionRelationship.AND});
        criteria1.expressions.push({operator: Operator.CloseBracket, relation: ExpressionRelationship.AND});
        criteria1.expressions.push({operator: Operator.OpenBracket, relation: ExpressionRelationship.AND});
      }
      criteria1.expressions.push(...criteria2.expressions);
      if (size > 0) {
        criteria1.expressions.push({operator: Operator.CloseBracket, relation: ExpressionRelationship.AND});
      }
    }
    return criteria1;
  }

  static addDefaultCriteriaTo(defaultCriteria: DTOCriteria | undefined, criteria: DTOCriteria | undefined, alwaysApplyDefaultCriteria: boolean | undefined): DTOCriteria | undefined {
    if (!defaultCriteria || !defaultCriteria.expressions || !defaultCriteria.expressions.length)
      return criteria;
    if (alwaysApplyDefaultCriteria)
      return defaultCriteria;
    let result: DTOCriteria = criteria ? {...criteria, expressions: [...(criteria.expressions ?? [])]} : {expressions: []};
    if (!result.expressions)
      result.expressions = [];
    let fieldOperatorSet = new Set(result.expressions.map(e => (e.field ?? '') + (e.operator ?? '')));
    for (let expression of defaultCriteria.expressions) {
      if (!fieldOperatorSet.has((expression.field ?? '') + (expression.operator ?? '')))
        result.expressions.push(expression);
    }
    return result;
  }

  static criteriaStrToMap(crt?: string) {
    if (!crt)
      return {};
    let map: Record<string, any> = {}
    if (!crt.trim().startsWith("#")) {
      map[""] = crt;
    } else {
      while (crt) {
        crt = crt.trim().substring(1);
        let entityType = StringUtils.substringBefore(crt, "{")!;
        crt = crt.substring(entityType.length + 1);
        let expression = StringUtils.substringBefore(crt, "#")!;
        if (expression.length > 0)
          expression = expression.substring(0, expression.length - 1);
        crt = crt.substring(expression.length + 1);
        map[entityType] = expression;
      }
    }
    return map;
  }

  static criteriaFromStr(strExpression?: string | null) {
    const OR_EMPTY = "OrEmpty";
    if (!strExpression)
      return undefined;
    let expressions: string[] = StringUtils.csvLineToList(strExpression, /[;\n\r]/);
    let criteria: DTOCriteria = {};
    for (let expression of expressions) {
      let parts: string[] = expression.split(",");
      if (parts.length > 0 && parts[0] != null && StringUtils.equalsIgnoreCase(parts[0].trim(), "distinct-values")) {
        criteria.distinctValues = true;
        continue;
      }
      if (parts.length < 2)
        continue;
      let fieldId = parts[0];
      let operatorStr = parts[1];
      let rightHandSide = parts.length > 2 ? parts[2] : "";
      if ((operatorStr ?? "").endsWith(OR_EMPTY)) {
        if (!rightHandSide)
          continue;
        operatorStr = operatorStr.substring(0, operatorStr.length - OR_EMPTY.length);
      }
      let operator = !operatorStr ? Operator.Equal : operatorStr;
      let relation = parts.length > 3 ? parts[3] : ExpressionRelationship.AND;
      if (!criteria.expressions)
        criteria.expressions = [];
      criteria.expressions.push({
        field: fieldId,
        operator: operator,
        rightHandSide: rightHandSide,
        relation: relation
      });
    }
    return criteria;
  }
}
